export default function TypingReceivingManager(chatRoom) {
  this.typingStack = [];
  this.DEFAULT_SECONDS_LIVE = 3;
  this.TIMEOUT_INTERVAL = 1000;

  this.room = chatRoom;
  this.userId = parseInt(document.body.dataset.userId);
  this.pushToStack = pushToStack.bind(this);

  initTimeout.call(this);

  function initTimeout() {
    setInterval(() => {
      this.typingStack.map((typer) => {
        typer.seconds--;
      });
      this.typingStack = this.typingStack.filter((typer) => typer.seconds > 0);
      renderTyping.call(this);
    }, this.TIMEOUT_INTERVAL);
  }

  function renderTyping() {
    const template = typingTemplate.call(this);
    const typingContainer = document.getElementById("typing-container");
    if (!typingContainer || typingContainer.innerHTML === template) {
      return;
    }

    if (this.typingStack.length) {
      typingContainer.innerHTML = template;
    }
  }

  function pushToStack(author) {
    if (author.user_id === this.userId) {
      return;
    }
    const isAuthorInStack = !!this.typingStack.filter(
      (typer) => typer.user_id === author.user_id && typer.user_type === author.user_type
    ).length;

    if (isAuthorInStack) {
      this.typingStack.map((typer) => {
        if (typer.user_id === author.user_id && typer.user_type === author.user_type) {
          typer.seconds = this.DEFAULT_SECONDS_LIVE;
        }
      });
    } else {
      this.typingStack.push({
        full_name: author.full_name,
        user_type: author.user_type,
        user_id: author.user_id,
        seconds: this.DEFAULT_SECONDS_LIVE,
        organization: author.organization,
      });
    }
  }

  function typingTemplate() {
    const verb = this.typingStack.length > 1 ? "are" : "is";
    const authorNames = this.typingStack
      .map((typer) => `${typer.full_name} | ${typer.organization.name}`)
      .join(", ");
    return `${authorNames} ${verb} typing<span>.</span><span>.</span><span>.</span>`;
  }
}
